export const cruiseModel = {
  ir1: {
    label: "ir1",
    name: "Deluxe Innenkabine (FANTASTICA)",
    price: {
      single: null,
      double: 1144
    }
  },
  ir2: {
    label: "ir2",
    name: "Deluxe Innenkabine (FANTASTICA)",
    price: {
      single: null,
      double: 1154
    }
  },
  oo: {
    label: "oo",
    name: "Deluxe Kabine mit Meerblick (FANTASTICA) teilweise Sichteinschränkung",
    price: {
      single: null,
      double: 1264
    }
  },
  or1: {
    label: "or1",
    name: "Deluxe Kabine mit Meerblick (FANTASTICA)",
    price: {
      single: null,
      double: 1334
    }
  },
  br1: {
    label: "br1",
    name: "Deluxe Balkonkabine (FANTASTICA)",
    price: {
      single: null,
      double: 1424
    }
  },
  br2: {
    label: "br2",
    name: "Deluxe Balkonkabine (FANTASTICA)",
    price: {
      single: null,
      double: 1434
    }
  },
  br3: {
    label: "br3",
    name: "Deluxe Balkonkabine (FANTASTICA)",
    price: {
      single: null,
      double: 1444
    }
  },
  ba: {
    label: "ba",
    name: "Balkonkabine (AUREA)",
    price: {
      single: null,
      double: 1594
    }
  },
  sl1: {
    label: "sl1",
    name: "Premium Suite (AUREA)",
    price: {
      single: null,
      double: 2024
    }
  },
  slj: {
    label: "slj",
    name: "Premium Suite (AUREA) mit Terrasse und Whirlpool",
    price: {
      single: null,
      double: 2324
    }
  },
  yc1: {
    label: "yc1",
    name: "Yacht Club Deluxe Suite",
    price: {
      single: null,
      double: 3087
    }
  }
}

const { ir1, ir2, oo, or1, br1, br2, br3, ba, sl1, slj, yc1 } = cruiseModel

export const cabins = {
  innen: [
    ir1,
    ir2
  ],
  balkon1: [
    oo,
    or1,
  ],
  balkon2: [
    br1,
    br2,
    br3
  ],
  premiumbalkon: [
    sl1,
    slj
  ], 
  balkonaurea: [
    ba
  ],
  yachtclub: [
    yc1
  ]
}

export const transfersModel = [
  {
    label: "transferByFlight",
    text: "per Flug über MSC für:",
    price: null,
    pricePrefix: "Ich wünsche eine Anfrage der An- und Abreise per Flug über MSC (inkl. Transfer)",
    priceSuffix: "",
    hasDestinationProvidedByUser: true
  },
  {
    label: "transferFromPortAirport",
    text: "Per Transfer vom Flughafen/Hafen",
    price: null,
    pricePrefix: "Ich wünsche eine Anfrage des Transfers vom Flughafen/Hafen",
    priceSuffix: "",
    hasDestinationProvidedByUser: false
  },
  {
    label: "embarkationGenoa",
    text: "Per Einschiffung Genua",
    price: null,
    pricePrefix: "Einschiffung von Genua am 19.10.2026 bis Ausschiffung am 24.10.2026",
    priceSuffix: "",
    hasDestinationProvidedByUser: false
  }
]

export const drinksOptions = [
  {
    label: "easy",
    name: "Das All-Inclusive-Getränkepaket EASY im Wert von 252,00 EUR ist inkludiert.",
    description: "Unbegrenzter Genuss alkoholfreier und alkoholischer Getränke. Ausgewählte Weine & Prosecco (glasweise, Weiß-, Rot- und Roséwein), Heinken Fassbier, Auswahl an alkoholischen und alkoholfreien Cocktails, Softdrinks und Fruchtsäfte im Glas, Mineralwasser in der Flasche und klassische Heißgetränke (Espresso, Cappuccino, Café Latte, Tee, etc.). Die im Paket enthaltenen Getränke können in fast allen Bars und (Buffet-)Restaurants verzehrt werden. Das Paket gilt nicht in Spezialitätenrestaurants. Für alkoholische Getränke gilt ein Limit von 15 Getränken pro Tag.",
    priceAdults: 0
  },
  {
    label: "premium-extra",
    name: "All-Inclusive Getränkepaket PREMIUM EXTRA",
    description: "Reichhaltige Auswahl alkoholfreier und alkoholischer Getränke. Große Auswahl an alkoholischen und alkoholfreien Cocktails, Markenspirituosen, Liköre und Mischgetränke, große Auswahl an Weinen und Champagner im Glas, alle Getränke in den Themenbars, 25% Rabatt auf Wein- und Champagnerflaschen, die an Bord erworben werden, Auswahl an Fass-, Craft- und Flaschenbieren, Softdrinks und Fruchtsäfte, Energy Drinks, Mineralwasser aus der Flasche, Heißgetränke (Espresso, Cappuccino, Latte Macchiato, Tee, etc.). Alle Getränke der Barkarte bis zu einem Preis von je 14,00 EUR. Die im Paket enthaltenen Getränke können in fast allen Bars und (Buffet-)Restaurants sowie in den Spezialitätenrestaurants verzehrt werden. Für alkoholische Getränke gilt ein Limit von 15 Getränken pro Tag.",
    priceAdults: 273
  },
  {
    label: "info",
    name: "Hinweise",
    description: "Bei allen Kabinenpreisen (außer der Yacht-Club-Suiten) ist das Getränkepaket All-Inclusive-Easy im Wert von 36,00 EUR pro Nacht, sowie die Hotel-Service-Gebühr in Höhe von 12,00 EUR pro Tag inkludiert. Das Upgrade der Getränkepakete vom inkludierten Getränkepaket Easy auf Premium Extra ist mit einem Aufpreis von 39,00 EUR pro Nacht möglich. Der Preis des Pakets kann nicht für einzelne Tage gebucht werden. Einmal an Bord aktiviert, kann das Paket nicht unterbrochen und erstattet werden. Das Paket muss von allen Gästen gebucht werden, welche sich in der gleichen Kabine aufhalten oder nur zusammen reisen und am gleichen Tisch essen möchten, einschließlich Minderjähriger, welche die Kinder-Version des Pakets buchen müssen. Das Paket ist nicht verpflichtend für Kinder unter 3 Jahren (d.h., Kinder, die ihren dritten Geburtstag noch nicht erreicht haben). Bei den Kabinenpreisen der Yacht-Club-Suiten gelten gesonderte Getränkeregelungen."
  }
]

export const congressAttendeeRoles = {
  dentist: {
    label:      "dentist",
    textMale:   "Zahnarzt",
    textFemale: "Zahnärztin",
    textPlural: "Zahnärztinnen, Zahnärzte",
    textSingular: "Zahnärztin, Zahnarzt"
  },
  assistantDentist: {
    label:      "assistantDentist",
    textMale:   "Assistenzzahnarzt",
    textFemale: "Assistenzzahnärztin",
    textPlural: "Assistenzzahnärztinnen, Assistenzzahnärzte",
    textSingular: "Assistenzzahnärztin, Assistenzzahnarzt"
  },
  technician: {
    label:      "technician",
    textMale:   "Zahntechniker",
    textFemale: "Zahntechnikerin",
    textPlural: "Zahntechnikerinnen, Zahntechniker",
    textSingular: "Zahntechnikerin, Zahntechniker"
  },
  assistant: {
    label:      "assistant",
    textMale:   "Zahnmedizinischer Fachangestellter",
    textFemale: "Zahnmedizinische Fachangestellte",
    textPlural: "Zahnmedizinische Fachangestellte",
    textSingular: "Zahnmedizinische(r) Fachangestellte(r)"
  }
}

export const congressPrice = {
  dentist: 940,
  assistantDentist: 550,
  technician: 500,
  assistant: 490
}

export const travelDocumentTypes = {
  passport: {
    text: "Reisepass"
  },
  idCard: {
    text: "Personalausweis"
  }
}

export const conferenceSessions = [
  "Digitalisierung in der Zahnarztpraxis",
  "Update Endodontologie",
  "Neuestes aus Implantologie und Oralchirurgie",
  "Neurologische Aspekte von Migräne, Gesichtsschmerz und Bruxismus",
  "Prothetikkonzepte",
  "Prophylaxe – ein Mehrwert für Patient und Praxis",
  "Hygienemanagement, Qualitätsmanagment – Vorbereitung für die Praxisbegehung",
  "GOZ - Abrechnung aktuell",
  "ePA und andere Herausforderungen",
  "Praxisabgabe und Neugründung",
  "Lachgas – Zertifizierungskurs (13 Fortbildungspunkte gegen Aufpreis)" 
]